import { render, staticRenderFns } from "./Moderator.vue?vue&type=template&id=521e797a&"
import script from "./Moderator.vue?vue&type=script&lang=js&"
export * from "./Moderator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521e797a')) {
      api.createRecord('521e797a', component.options)
    } else {
      api.reload('521e797a', component.options)
    }
    module.hot.accept("./Moderator.vue?vue&type=template&id=521e797a&", function () {
      api.rerender('521e797a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questions/Moderator.vue"
export default component.exports